import { createContext } from 'react';

const placesContext = createContext();

export default placesContext;
